<template>
	<div id="app">
		<router-view/>
		<Live2DWidget v-if="routeReady && !isFullScreenPage" />
	</div>
</template>

<script>
	import Live2DWidget from '@/components/live2d/Live2DWidget'

	export default {
		name: 'app',
		components: {
			Live2DWidget
		},
		data() {
			return {
				routeReady: false
			}
		},
		created() {
			// 等待路由首次解析完成后再挂载小人，避免全屏页首屏误挂载
			this.$router.onReady(() => {
				this.routeReady = true
			})
		},
		computed: {
			/**
			 * 是否全屏独立页（/fx、/tab），这类页面不显示全局小人组件
			 */
			isFullScreenPage() {
				const path = (this.$route.path || '/').replace(/\/+$/, '')
				return path === '/fx' || path === '/tab'
			}
		},
		watch: {
			isFullScreenPage(value) {
				if (value) {
					this.removeLive2DWidget()
				}
			}
		},
		mounted() {
			if (this.isFullScreenPage) {
				this.removeLive2DWidget()
			}
		},
		methods: {
			/**
			 * 移除 Live2D 官方组件注入到 body 的残留节点
			 *
			 * <p>组件销毁时 L2Dwidget 生成的 DOM 不一定被清理，进入全屏页时需要手动移除。</p>
			 */
			removeLive2DWidget() {
				const widget = document.getElementById('live2d-widget')
				if (widget && widget.parentNode) {
					widget.parentNode.removeChild(widget)
				}
			}
		}
	}
</script>

<style>

</style>